<script lang="ts">
    import { useLocation } from "svelte-navigator";
    import { appManager } from "../AppManager";

    const location = useLocation();

    async function authenticate() {
        const from = ($location.state && $location.state.from) || "/";
        await appManager.startSignin(from);
    }
</script>

{#await authenticate()}
    <div />
{/await}
